import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-table",
  "use": "icon-table-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-table\"><path d=\"M30 21V8c0-2.2-1.8-4-4-4H6C3.8 4 2 5.8 2 8v16c0 2.2 1.8 4 4 4h20c2.2 0 4-1.8 4-4zm-18 5v-3h8v3zm0-5v-3h8v3zm8-8v3h-8v-3zm8 3h-6v-3h6zm-6 2h6v3h-6zM4 24V8c0-1.2.8-2 2-2h20c1.2 0 2 .8 2 2v3H4v2h6v3H4v2h6v3H4v2h6v3H6c-1.2 0-2-.8-2-2m24 0c0 1.2-.8 2-2 2h-4v-3h6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol